import React from "react";
import { configurations } from "../../configurations";
import { URLdecode, URLencode } from "../../utils/url";
import { useLocation, useNavigate } from "react-router-dom";

function PointsHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = URLdecode();
  const tabs = [
    configurations.milesPoints.tabs.mission,
    configurations.milesPoints.tabs.badge,
    configurations.milesPoints.tabs.reward,
    configurations.milesPoints.tabs.leaderboard,
    configurations.milesPoints.tabs.log,
  ];
  return (
    <div className="w-full rounded-md bg-white p-2 border border-gray-300 flex">
      {tabs.map((tab, tabIndex) => {
        const selectedTab = params?.tab || tabs[0].code;
        const isSelected = selectedTab === tab.code;
        return (
          <button
            key={tabIndex}
            className={`flex flex-1 h-11 items-center justify-center text-sm font-semibold rounded-md ${
              isSelected ? "bg-primary1 text-white" : "bg-white text-[#6D7C94]"
            }`}
            onClick={() => {
              navigate(
                `${location.pathname}?${URLencode({
                  ...params,
                  tab: tab.code,
                })}`
              );
            }}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}

export default PointsHeader;
